import { Button } from '@ledgerloom/ui';
import { useState } from 'react';
import { Icon } from './ui';

// A form's embed code, to paste into the workspace's own site: shown on
// request, with a copy button. Pattern: content-management/accordion (one native details).
export function EmbedCode({ name, code }: { name: string; code: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <details>
      <summary>Embed code for {name}</summary>
      <div className="stack" style={{ gap: 6, marginTop: 6 }}>
        <p className="small muted" style={{ margin: 0 }}>Paste this into your site's page where the form goes. Submissions arrive here as leads.</p>
        <pre className="mono small" style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all', maxHeight: 200, overflow: 'auto' }} tabIndex={0}><code>{code}</code></pre>
        <div>
          <Button type="button" variant="secondary" size="sm" onClick={() => { void navigator.clipboard?.writeText(code).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }); }}>
            <Icon name={copied ? 'check' : 'copy'} />{copied ? 'Copied' : 'Copy'}
          </Button>
        </div>
      </div>
    </details>
  );
}
